
import { ModalController, ViewController,NavParams } from 'ionic-angular';

import { Component } from '@angular/core';
import { NavController, AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { UploadService } from '../../../services/upload-service';
import { Upload } from '../../../services/upload';

declare var cordova: any;

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ProgressBarComponent } from '../../../components/progress-bar/progress-bar';
import * as firebase from "firebase";

@Component({
    selector: 'page-document-viewer',
    templateUrl: 'document-viewer.html'
})
export class DocumentViewer {

    document: string = null;

    constructor(
        public storage: Storage,
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,
        private camera: Camera,
        public actionSheetCtrl: ActionSheetController,
        public toastCtrl: ToastController,
        public platform: Platform,
        public loadingCtrl: LoadingController,
        public uploadService: UploadService

    ) {

        //this.jobList = this.uiData.jobList();
        this.document=params.get('document');

    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/utils/document-viewer/document-viewer.ts